import React, { createRef, RefObject, useEffect } from 'react';
import { findAccountsDtlPage,  } from '@/services/insureManagement'
import { message } from "antd";
import { SLowcodeList } from 'shj-components';
import dayjs from 'dayjs';
import { getWorkTypeList } from '@/services';
import { moneyRender } from '@/utils';

export default function () {
    const listRef: RefObject<any> = createRef();
    let config = {
        rowSelection: false,
        searchFormConfig: false,
        columns: [
            {
                title: "门店",
                dataIndex: "companyName",
                width: 160
            },
            {
                title: "姓名",
                dataIndex: "extEmpName",
                width: 100
            },
            {
                title: "技能标签",
                dataIndex: "workTypeNames",
                width: 120,
                ellipsis: true,
            },
            {
                title: "身份证号码",
                dataIndex: "idCard",
                width: 160,
            },
            {
                title: "金额(¥)",
                dataIndex: "amount",
                width: 100,
                render: 'money'
            },
            {
                title: "创建时间",
                dataIndex: "createdTime",
                itemType: "dateTime",
                width: 160
            },
            {
                title: "投保周期",
                dataIndex: "insureCycle",
                width: 180,
                render: "insureCycleFn"
            },
            {
                title: "备注",
                dataIndex: "remarks",
                render: "remarkFn",
                ellipsis: true,
                width: 200
            }
        ],
        search: [
            {
                name: "workTypeIds",
                label: "技能标签",
                itemType: "select",
                key: "id",
                labelKey: "name",
                showSearch: true,
                optionFilterProp: "children",
                allowClear: true,
                mode: "multiple",
                data: "workTypeList"
            },
            {
                name: "searchName",
                label: "姓名/身份证号"
            }
        ],
        footer: [
            {
                label: "导出",
                events: ["onClick:onExport"]
            },
        ]
    }
    const fetchList = (values) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query } = values;
                findAccountsDtlPage(current, pageSize, query).then(data => resolve(data))
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const getWorkTypeArr = () => {
        return getWorkTypeList().then((response: any) => {
            return response;
        });
    };
    const onExport = () => {
        const searchObj = listRef?.current?.getSearch()?.getFieldsValue();
        if (searchObj?.worktypeCodes) {
            searchObj.worktypeCodes = searchObj.worktypeCodes.join(',')
        }
        if (searchObj?.operateTypeCodes) {
            searchObj.operateTypeCodes = searchObj.operateTypeCodes.join(',')
        }
        if (searchObj?.companySCodes) {
            searchObj.companySCodes = searchObj.companySCodes.join(',')
        }
        if (searchObj?.amountTypes) {
            searchObj.amountTypes = searchObj.amountTypes.join(',')
        }
        if (searchObj?.amountTypes1) {
            searchObj.amountTypes = searchObj.amountTypes1.join(',')
            delete searchObj.amountTypes1
        }
        message.loading({ content: '导出中' })
        // exportInsurAccountsAll(searchObj).then((res) => {
        //     if (res.status) {
        //         message.destroy()
        //         fileConfirm()
        //     } else {
        //         message.error('下载失败')
        //         message.destroy()
        //     }
        // })
    }
    const getStatusOptions = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const workTypeList = await getWorkTypeArr();
                resolve({
                    workTypeList,
                });
            } catch (e) { }
        });
    };
    const extension = {
        request: { fetchList, getStatusOptions },
        events: {
            onExport
        },
        customRender: {
            insureCycleFn(_: any, record: any) {
                return dayjs(record.startTime).format('YYYY-MM-DD') + ' 至 ' + dayjs(record.endTime).format('YYYY-MM-DD')
            },
            money(text: any) {
                return <span>{moneyRender(text)}</span>
            },
        }
    };

    useEffect(() => {
        getStatusOptions()
        listRef?.current?.reload();
    }, []);
    return (
        <SLowcodeList
            searchMode="group"
            ref={listRef}
            config={config}
            {...extension}
        />
    );
};